<ngb-toast *ngFor="let toast of toastService.toasts" [class]="toast.classname + ' text-light' " [autohide]="true"
    [delay]="toast.delay || 5000" (hidden)="toastService.remove(toast)">


    <div class="row">
        <div class="col-2" style="font-size: 30px;">
            <span *ngIf="toast.classname === 'bg-danger'">
                <i class="fa fa-times-circle"></i>
            </span>
        </div>

        <div class="col-10">
            <span style="font-size: 14px; font-weight: bolder;">Estimado usuario</span><br>
            {{ toast.textOrTpl }}
        </div>
    </div>
</ngb-toast>